import { Component, OnInit } from '@angular/core';
import { UIBaseService } from '../../../services/uibase.service';

@Component({
    selector: 'cop-public-latest-news',
    templateUrl: './public-latest-news.component.html',
    styleUrls: ['./public-latest-news.component.scss'],
    standalone: false
})

export class PublicLatestNewsComponent implements OnInit {
  mainObj: any = null;
  latestNews: any[] = [];
  showNavigationArrows: boolean = true;
  showNavigationIndicators: boolean = false;

  constructor(private uiBase: UIBaseService) { }

  ngOnInit() {
    // this.mainObj = this.uiBase.getDataFromVar("LinkComponent1397395779882");
    this.mainObj = this.uiBase.getDataFromVar("CopLinkComponent1397395779882");
    if(this.mainObj && this.mainObj.headerLinks && this.mainObj.headerLinks.length)
      this.latestNews = this.mainObj.headerLinks;
  }
}
